import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫大全',
  url: 'https://www.hanmandq.com/',
  description: '韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰，让您享受纯净阅读时光。',
  inLanguage: 'zh-Hans',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫大全',
  url: 'https://www.hanmandq.com/',
  description: '韩国漫画无删减下拉式免费韩漫大全平台',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩国漫画和无删减漫画有什么区别？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩国漫画原版通常包含完整的故事情节和画面细节，而无删减版本保留了原版漫画的所有内容。我们平台提供的韩国漫画均为无删减版本，确保您获得最完整的阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '什么是下拉式韩漫阅读方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '下拉式阅读是韩国漫画（Webtoon）的特色阅读方式，区别于传统日漫的翻页模式。您可以像浏览网页一样，通过向下滚动屏幕来连续阅读漫画内容，让阅读更加流畅自然。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网站的漫画资源是否真的免费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的！我们韩漫网站致力于打造免费韩漫大全平台，所有漫画资源均免费提供阅读。我们希望让每一位喜爱韩国漫画的读者都能无负担地享受阅读乐趣。',
      },
    },
    {
      '@type': 'Question',
      name: '平台上的漫画多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们与韩国漫画原作者和出版社保持密切合作，确保漫画更新同步。大部分连载中的韩国漫画每周更新一话，热门作品可能会更频繁。',
      },
    },
    {
      '@type': 'Question',
      name: '为什么选择下拉式韩国漫画而非传统翻页漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '下拉式格式是韩国网漫（Webtoon）的核心特色。它专为数字屏幕设计，通过纵向排布让画面之间的过渡更加流畅，给予读者更强的沉浸感。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网站支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的平台采用响应式设计，完美支持手机、平板和电脑端阅读。无论您使用什么设备，都能获得流畅的下拉式韩国漫画阅读体验。',
      },
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedComics />
          <LatestUpdates />
          <CTASection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}